import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import { FileUploadModalBody } from '@rd-web-markets/shared/dist/util';
const CompetentProfessionalImportModal = _ref => {
  let {
    show,
    onHide,
    importTemplate
  } = _ref;
  const {
    t
  } = useTranslation();
  const [uploadAllowed, setUploadAllowed] = useState(false);
  const [fileNotSelected, setFileNotSelected] = useState(false);
  useEffect(() => {
    if (!show) {
      setUploadAllowed(false);
    }
  }, [show]);
  const upload = useCallback(formData => {
    importTemplate(formData);
  }, [importTemplate]);
  const renderBody = /*#__PURE__*/React.createElement(FileUploadModalBody, {
    uploadAllowed: uploadAllowed,
    upload: upload,
    setFileNotSelected: setFileNotSelected
  });
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: t('import_employee_data'),
    show: show,
    renderBody: () => renderBody,
    onHide: onHide,
    onSubmit: () => setUploadAllowed(true),
    submitText: t('import'),
    disabled: fileNotSelected
  });
};
export default CompetentProfessionalImportModal;